import SectionHeading from "./SectionHeading";
import { contactInfo, locationInfo } from "@/mocks/home";

export default function Location() {
  const infoCards = [
    {
      icon: "ri-map-pin-2-line",
      title: "주소",
      desc: contactInfo.address,
    },
    ...locationInfo.transit,
    ...locationInfo.parking,
  ];

  return (
    <section id="location" className="w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Location"
          title="오시는 길"
          highlight="안내"
          desc="강남역 2번 출구에서 도보 3분 거리입니다. 방문 전 전화로 예약하시면 대기 없이 바로 진단받을 수 있습니다."
        />

        <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_1fr] lg:gap-10">
          <div className="reveal overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-[320px] w-full md:h-[420px] lg:h-[480px]">
              <iframe
                src={locationInfo.mapEmbedSrc}
                title="맥픽스 오시는 길 지도"
                aria-label="맥픽스 위치 구글 지도"
                className="h-full w-full border-0"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              ></iframe>
            </div>
            <div className="flex flex-col items-start justify-between gap-4 border-t border-background-200 p-5 sm:flex-row sm:items-center">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className="ri-direction-line text-xl"></i>
                </span>
                <div>
                  <p className="font-heading text-base font-black text-foreground-950">
                    맥픽스 강남 본점
                  </p>
                  <p className="mt-0.5 font-body text-xs text-foreground-600">
                    테헤란로 152 맥픽스타워 8층
                  </p>
                </div>
              </div>
              <a
                href={locationInfo.directionsHref}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
              >
                <i className="ri-navigation-fill text-base"></i>
                길찾기
              </a>
            </div>
          </div>

          <div className="reveal flex flex-col gap-4">
            {infoCards.map((card) => (
              <div
                key={card.title}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${card.icon} text-xl`}></i>
                </span>
                <div>
                  <p className="font-label text-sm font-bold text-foreground-950">{card.title}</p>
                  <p className="mt-1 font-body text-sm leading-relaxed text-foreground-600">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}

            <div className="flex items-center gap-4 rounded-lg border border-primary-200 bg-primary-50 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-time-line text-xl"></i>
              </span>
              <div>
                <p className="font-label text-sm font-bold text-primary-900">운영 시간</p>
                <p className="mt-1 font-body text-sm leading-relaxed text-primary-800">
                  {contactInfo.hours}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}